/* Nourish London - independent predictive search component.
   Deliberately does not change Prestige's existing currency or cart JS.
   Uses Shopify locale-aware Ajax suggest API plus optional public metaobjects.
*/
(function () {
  'use strict';

  function element(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (typeof text === 'string') el.textContent = text;
    return el;
  }
  function normalised(text) {
    return String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  }
  function localHref(value, root) {
    try {
      var url = new URL(String(value || ''), window.location.origin);
      if (url.origin !== window.location.origin) return null;
      // Some theme objects return /pages/... without the selected market prefix.
      if (root !== '/' && /^\/(pages|blogs|collections|products)\//.test(url.pathname)) {
        url.pathname = root.replace(/\/$/, '') + url.pathname;
      }
      return url.pathname + url.search + url.hash;
    } catch (e) { return null; }
  }
  function init(header) {
    if (!header || header.dataset.nourishPredictiveReady === 'true') return;
    var input = header.querySelector('.HeaderSearchPanel input[name="q"]');
    var panel = header.querySelector('[data-nourish-predictive]');
    var content = panel && panel.querySelector('[data-nourish-predictive-content]');
    var status = panel && panel.querySelector('[data-nourish-predictive-status]');
    var form = input && input.closest('form');
    if (!input || !panel || !content || !form) return;
    header.dataset.nourishPredictiveReady = 'true';
    var root = panel.dataset.storefrontRoot || '/';
    if (root.slice(-1) !== '/') root += '/';
    var sequence = 0;
    var request = null;
    var timeout = null;
    var topicElements = header.querySelectorAll('[data-nourish-index-entry]');
    var topics = Array.prototype.map.call(topicElements, function (el) {
      return { title: el.dataset.title || '', summary: el.dataset.summary || '', url: el.dataset.url || '', type: el.dataset.type || '' };
    });
    var hubLinks = [
      {title: 'Ingredients', path: 'pages/ingredients'},
      {title: 'Skin concerns', path: 'pages/skin-concerns'},
      {title: 'Skincare routines', path: 'pages/regimes'},
      {title: 'Education Hub', path: 'pages/education'}
    ];

    function setVisible(visible) {
      panel.hidden = !visible;
      input.setAttribute('aria-expanded', visible ? 'true' : 'false');
    }
    function itemAnchor(url, title, subtitle, imageUrl) {
      var href = localHref(url, root);
      if (!href) return null;
      var link = element('a', 'NourishPredictive__Item');
      link.href = href;
      if (imageUrl) {
        try {
          var imgUrl = new URL(imageUrl, window.location.origin);
          if (imgUrl.protocol === 'https:' || imgUrl.protocol === 'http:') {
            var img = element('img', 'NourishPredictive__Image');
            img.src = imgUrl.href;
            img.alt = '';
            img.loading = 'lazy';
            link.appendChild(img);
          }
        } catch(e) { /* Ignore missing product images. */ }
      } else {
        var symbol = element('span', 'NourishPredictive__Icon', '↗');
        symbol.setAttribute('aria-hidden', 'true');
        link.appendChild(symbol);
      }
      var holder = element('span', 'NourishPredictive__ItemText');
      holder.appendChild(element('span', 'NourishPredictive__Title', title));
      if (subtitle) holder.appendChild(element('span', 'NourishPredictive__Subtitle', subtitle));
      link.appendChild(holder);
      return link;
    }
    function addGroup(host, title, items, gridClass) {
      if (!items.length) return;
      var group = element('section', 'NourishPredictive__Group');
      group.appendChild(element('h3', 'NourishPredictive__Heading', title));
      var grid = element('div', gridClass || 'NourishPredictive__Education');
      items.forEach(function (item) {
        var a = itemAnchor(item.url, item.title, item.subtitle, item.image);
        if (a) grid.appendChild(a);
      });
      if (!grid.children.length) return;
      group.appendChild(grid);
      host.appendChild(group);
    }
    function productPhoto(item) {
      var src = item.featured_image || item.image;
      if (typeof src === 'string') return src;
      return (src && (src.url || src.src)) || '';
    }
    function category(type) {
      if (type === 'ingredient') return 'Ingredient guide';
      if (type === 'skin_concern') return 'Skin concern';
      if (type === 'regime' || type === 'routine') return 'Skincare routine';
      return 'Skincare education';
    }
    function maybeEducation(item, subtitle) {
      return { title: item.title || '', subtitle: subtitle || 'Education Hub', url: item.url || '' };
    }
    function matchesTopics(query) {
      var words = normalised(query).split(/\s+/).filter(Boolean);
      return topics.filter(function (topic) {
        var haystack = normalised(topic.title + ' ' + topic.summary);
        return words.every(function (word) { return haystack.indexOf(word) !== -1; });
      }).slice(0, 7).map(function (topic) {
        return { title: topic.title, url: topic.url, subtitle: category(topic.type) };
      });
    }
    function render(query, result, error) {
      if (normalised(input.value) !== normalised(query) || header.querySelector('.HeaderSearchPanel').hidden) return;
      content.replaceChildren();
      var entries = (result && result.resources && result.resources.results) || {};
      var products = (entries.products || []).slice(0, 6).map(function (p) {
        return {title: p.title || '', url: p.url || '', subtitle: 'Product', image: productPhoto(p)};
      });
      var education = matchesTopics(query);
      var known = new Set(education.map(function (e) {return (localHref(e.url, root) || '').split('?')[0];}));
      (entries.pages || []).concat(entries.articles || []).forEach(function (p) {
        var url = localHref(p.url, root);
        if (!url || known.has(url.split('?')[0])) return;
        known.add(url.split('?')[0]);
        education.push(maybeEducation(p, 'Skincare guide'));
      });
      education = education.slice(0, 8);
      var collections = (entries.collections || []).slice(0, 3).map(function (p) {
        return {title:p.title || '', url:p.url || '', subtitle:'Collection'};
      });
      if (error) content.appendChild(element('p', 'NourishPredictive__Message', 'Live suggestions are unavailable. You can still search the website.'));
      addGroup(content, 'Products', products, 'NourishPredictive__Products');
      addGroup(content, 'Learn with Nourish', education, 'NourishPredictive__Education');
      addGroup(content, 'Collections', collections, 'NourishPredictive__Education');
      if (!products.length && !education.length && !collections.length && !error) {
        content.appendChild(element('p', 'NourishPredictive__Message', 'No immediate matches. Try a shorter term or browse our Education Hub.'));
      }
      var more = element('section', 'NourishPredictive__Group');
      more.appendChild(element('h3', 'NourishPredictive__Heading', 'Explore skincare science'));
      var hubArea = element('div', 'NourishPredictive__Hubs');
      hubLinks.forEach(function (hub) {
        var a = element('a', 'NourishPredictive__Hub', hub.title);
        a.href = root + hub.path;
        hubArea.appendChild(a);
      });
      more.appendChild(hubArea);
      content.appendChild(more);
      var footer = element('div', 'NourishPredictive__Footer');
      var viewAll = element('a', 'NourishPredictive__ViewAll', 'View all results for “' + query + '”');
      viewAll.href = form.action + '?q=' + encodeURIComponent(query);
      footer.appendChild(viewAll);
      content.appendChild(footer);
      status.textContent = products.length + ' products and ' + education.length + ' educational results suggested.';
      setVisible(true);
    }
    function search(query) {
      var mySequence = ++sequence;
      if (request) request.abort();
      request = new AbortController();
      var base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || root;
      if (base.slice(-1) !== '/') base += '/';
      var params = new URLSearchParams();
      params.set('q', query);
      params.set('resources[type]', 'product,page,article,collection');
      params.set('resources[limit]', '8');
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][fields]', 'title,body,tag');
      params.set('resources[options][unavailable_products]', 'last');
      fetch(base + 'search/suggest.json?' + params.toString(), { signal: request.signal, credentials: 'same-origin' })
        .then(function (res) { if (!res.ok) throw new Error('Suggest request failed: ' + res.status); return res.json(); })
        .then(function (result) { if (mySequence === sequence) render(query, result, false); })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          if (mySequence === sequence) render(query, null, true);
        });
    }
    input.addEventListener('input', function () {
      clearTimeout(timeout);
      sequence++;
      if (request) request.abort();
      var q = input.value.trim();
      if (q.length < 2) { setVisible(false); content.replaceChildren(); status.textContent = ''; return; }
      timeout = setTimeout(function () { search(q); }, 230);
    });
    // Keyboard operation: Tab through native links, Escape closes header panel.
    input.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' && !panel.hidden) {
        var link = panel.querySelector('a');
        if (link) { event.preventDefault(); link.focus(); }
      }
    });
    panel.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowUp' && event.target.tagName === 'A') {
        var links = Array.prototype.slice.call(panel.querySelectorAll('a'));
        if (event.target === links[0]) { event.preventDefault(); input.focus(); }
      }
    });
    document.addEventListener('click', function (event) {
      if (!header.contains(event.target)) setVisible(false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setVisible(false);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.contains(header)) { clearTimeout(timeout); if (request) request.abort(); }
    });
  }
  function initAll() {
    document.querySelectorAll('.shopify-section--header .Header').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
